import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=053b24d7&scoped=true"
import script from "./associationDetail.vue?vue&type=script&lang=js"
export * from "./associationDetail.vue?vue&type=script&lang=js"
import style0 from "./associationDetail.vue?vue&type=style&index=0&id=053b24d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b24d7",
  null
  
)

export default component.exports